import React from "react";

function InfoCircle(props) {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM10.75 14.5C10.75 14.914 10.414 15.25 10 15.25C9.586 15.25 9.25 14.914 9.25 14.5V9.92896C9.25 9.51496 9.586 9.17896 10 9.17896C10.414 9.17896 10.75 9.51496 10.75 9.92896V14.5ZM10.02 7.5C9.46802 7.5 9.01489 7.052 9.01489 6.5C9.01489 5.948 9.45801 5.5 10.01 5.5H10.02C10.573 5.5 11.02 5.948 11.02 6.5C11.02 7.052 10.572 7.5 10.02 7.5Z" fill="#F27327"/>
    </svg>
  );
}

export default InfoCircle;